function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { createCarouselComponent, generateCarouselId } from 'instantsearch-ui-components';
import React, { createElement, Fragment, useRef } from 'react';
var CarouselUiComponent = createCarouselComponent({
  createElement: createElement,
  Fragment: Fragment
});
export function Carousel(props) {
  var carouselRefs = {
    listRef: useRef(null),
    nextButtonRef: useRef(null),
    previousButtonRef: useRef(null),
    carouselIdRef: useRef(generateCarouselId())
  };
  return /*#__PURE__*/React.createElement(CarouselUiComponent, _extends({}, carouselRefs, props));
}